module.exports = __webpack_public_path__ + "static/media/turnado.ef1ed611.gif";